var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bg_bg02",
    "data-name": "bg / bg02",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 414,
    height: 896,
    viewBox: "0 0 414 896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    width: 414,
    height: 896,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg_bg02_background",
    "data-name": "bg / bg02 background",
    width: 414,
    height: 896
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask-2",
    "data-name": "mask",
    width: 414,
    height: 896,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_6",
    "data-name": "Enmascarar grupo 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg",
    transform: "translate(-326 -130.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(796.938 579.207) rotate(-135)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    d: "M243.639,121.617C243.639,54.45,189.1,0,121.82,0S0,54.45,0,121.617",
    transform: "translate(144.131 0.967)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    transform: "translate(526.006 291.11) rotate(-180)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.294,
    height: 210.223,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 509.294,
    height: 194.223,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy_2",
    "data-name": "Rectangle Copy 2",
    transform: "translate(396.41 291.11) rotate(-180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.647,
    height: 83.394,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 246.647,
    height: 67.394,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 215,
    cy: 215,
    r: 215,
    transform: "translate(0 578.793)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeMiterlimit: 10,
    strokeWidth: 16
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/Background1.19ba048e7f814d3297a5faa89afe390c.svg";
export { ForwardRef as ReactComponent };